module.exports = __webpack_public_path__ + "media/images/number_11-11be24f7721d661d407e86968bfd897b.png";